module.exports = __webpack_public_path__ + "static/media/Kommentereren.cb861c13.png";